module.exports = __webpack_public_path__ + "img/students3.7820f41c.jpg";